module.exports = __webpack_public_path__ + "static/media/10-mob.35fba6b9.png";